import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Store } from '@ngrx/store';
import isNull from 'lodash/isNull';
import isUndefined from 'lodash/isUndefined';
import { map, Observable, of } from 'rxjs';
import { take, withLatestFrom } from 'rxjs/operators';
import { LocalizationService } from '@capital-access/common/localization';
import { BaseAsyncPipe } from '@capital-access/common/utils';
import { getAccountUsers, getAccountUsersFailed } from '../+state/account-users.selectors';
import { LOCALIZATION_SCOPE } from '../constants';

@Pipe({ name: 'caAccountUserFullName', pure: false })
export class AccountUserFullNamePipe extends BaseAsyncPipe<string, number | null | undefined> implements PipeTransform {
  constructor(
    private store: Store,
    private localizationService: LocalizationService,
    changeDetectorRef: ChangeDetectorRef
  ) {
    super(changeDetectorRef);
  }

  getTransformer(id?: number | null): Observable<string> {
    if (isNull(id) || isUndefined(id)) return of('');
    return this.localizationService.getLocalization(LOCALIZATION_SCOPE).pipe(
      withLatestFrom(this.store.select(getAccountUsersFailed), this.store.select(getAccountUsers)),
      take(1),
      map(([localization, isFailed, users]) => {
        if (isFailed) return localization['failedUserName'];
        const accountUser = users.find(accountUser => accountUser.id === id);
        return accountUser ? `${accountUser?.firstName} ${accountUser?.lastName}` : localization['inActiveUser'];
      })
    );
  }
}
